module.exports = __webpack_public_path__ + "static/media/dragonfruit.12c6fdcb.webp";